<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'资产编号'" v-model="listQuery.assetCode"> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'名称或规格'" v-model="listQuery.key"> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 100px;" class="filter-item"
          :placeholder="'部门'" v-model="listQuery.department"> </el-input>
        <el-date-picker v-model="dateRange" type="daterange" size="small" class="filter-item" style="width: 260px;"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
          @change="handleDateRangeChange">
        </el-date-picker>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 80px;" class="filter-item"
          :placeholder="'最小金额'" v-model.number="listQuery.minAmount" type="number"> </el-input>
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 80px;" class="filter-item"
          :placeholder="'最大金额'" v-model.number="listQuery.maxAmount" type="number"> </el-input>

        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <!-- <el-button class="filter-item" size="small" v-waves icon="el-icon-refresh" @click="handleReset">重置</el-button> -->
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" :v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true" @sort-change="handleSortChange" @filter-change="handleFilterChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="950px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <el-row :gutter="10">
          <el-tabs type="border-card">
            <el-tab-pane label="基本资料">
              <el-form ref="dataForm" :model="temp" :rules="rules" size="medium" label-width="80px"
                label-position="left">
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="资产编号" prop="assetCode">
                        <el-input v-model="temp.assetCode" clearable :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="资产名称" prop="assetName">
                        <el-input v-model="temp.assetName" placeholder="资产名称" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="使用年限" prop="serviceLife">
                        <el-input v-model="temp.serviceLife" placeholder="使用年限" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="购买日期" prop="purchaseDate">
                        <el-date-picker v-model="temp.purchaseDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          :style="{ width: '100%' }" placeholder="请选择购买日期" clearable></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="使用单位" prop="useUnit">
                        <el-input v-model="temp.useUnit" placeholder="使用单位" readonly
                          :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="购买金额" prop="purchaseAmount">
                        <el-input v-model="temp.purchaseAmount" placeholder="购买金额" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="RFID" prop="rfid">
                        <el-input v-model="temp.rfid" placeholder="请输入RFID" clearable
                          :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="规格" prop="specification">
                        <el-input v-model="temp.specification" placeholder="请输入规格" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="资产残值" prop="assetResidual">
                        <el-input v-model="temp.assetResidual" placeholder="资产残值" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="SN号" prop="serialNumber">
                        <el-input v-model="temp.serialNumber" placeholder="SN号" clearable
                          :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="折旧方法" prop="depreciations">
                        <el-input v-model="temp.depreciations" placeholder="请输入折旧方法" clearable
                          :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="累计折旧" prop="assetAd">
                        <el-input v-model="temp.assetAd" placeholder="累计折旧" clearable
                          :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="使用部门" prop="useDepartment">
                        <el-input v-model="temp.useDepartment" placeholder="使用部门" clearable :style="{ width: '100%' }">
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>

                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="仓库" prop="storeName">
                        <el-input v-model="temp.storeName" clearable :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-row>
                    <el-col :span="23">
                      <el-form-item label="使用人" prop="useMan">
                        <el-input v-model="temp.useMan" placeholder="使用人" clearable
                          :style="{ width: '100%' }"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-form>

            </el-tab-pane>
            <el-tab-pane label="变动记录">
              <el-table :data="changeRecords" style="width: 100%;height: 300px;overflow: auto;" border>
                <!-- <el-table-column prop="assetCode" label="资产编号" width="120"></el-table-column>
                <el-table-column prop="assetName" label="资产名称" width="150"></el-table-column>
                <el-table-column prop="specification" label="规格" width="120"></el-table-column> -->
                <el-table-column prop="changeDate" label="变动时间" width="130" show-overflow-tooltip></el-table-column>
                <el-table-column prop="businessType" label="业务类型" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="originalStore" label="原仓库" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="newStore" label="现仓库" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="originalDepartment" label="原部门" width="120"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="originalUser" label="原使用人" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="department" label="使用部门" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="handler" label="使用人" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operator" label="操作人" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip></el-table-column>
              </el-table>
              <pagination v-show="changeRecordsTotal > 0" :total="changeRecordsTotal"
                :page.sync="changeRecordsQuery.page" :limit.sync="changeRecordsQuery.limit"
                @pagination="handleChangeRecordsPagination" />
            </el-tab-pane>
            <el-tab-pane label="二维码">
              <div class="asset-card-container">
                <div class="asset-card">
                  <div class="card-header">{{ tenantName || 'FAE资产E管家' }}资产卡片</div>
                  <div class="card-body">
                    <div class="card-left">
                      <div class="info-row">
                        <span class="label">名称：</span>
                        <span class="value">{{ temp.assetName || '' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">编号：</span>
                        <span class="value">{{ temp.assetCode || '' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">规格：</span>
                        <span class="value">{{ temp.specification || '' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">科室：</span>
                        <span class="value">{{ temp.useDepartment || '' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">日期：</span>
                        <span class="value">{{ temp.purchaseDate || '' }}</span>
                      </div>
                      <div class="info-row">
                        <span class="label">金额</span>
                        <span class="value">{{ temp.purchaseAmount || '' }}元</span>
                      </div>
                      <div class="qr-code-text">{{ temp.rfid || '' }}</div>
                    </div>
                    <div class="card-right">
                      <canvas ref="qrCanvas"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>



        </el-row>


        <div slot="footer">
          <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="small" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="small" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog title="批量修改" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">

        <el-form :model="batchForm" ref="batchForm" label-width="100px">
          <!-- 下拉选择要修改的字段 -->
          <el-form-item label="修改字段" prop="field">
            <el-select v-model="batchForm.field" placeholder="请选择要修改的字段" @change="handleFieldChange">
              <el-option v-for="item in headerList" :key="item.columnName" :label="item.remark"
                :value="item.columnName">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 输入新值 -->
          <el-form-item label="新值" prop="value">
            <el-input v-model="batchForm.value" placeholder="请输入新值" :type="inputType">
            </el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleBatchUpdate">确 定</el-button>
        </span>
      </el-dialog>

      <importDialog ref="ImportDialog" v-show="importDialogVisible" @reloadTable="getList" :FileName="FileName"
        :url="url"></importDialog>
    </div>
  </div>
</template>
<script>
import * as assetInfos from '@/api/basic/assetInfos'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
import importDialog from '../../../components/Base/importDialog.vue'
import QRCode from 'qrcode';
import { getTenantList } from '@/api/basic/tenantUsers'

export default {
  name: 'assetInfo',
  components: { Sticky, permissionBtn, Pagination, AuthTable, importDialog },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      tenantName: '', // 单位名称
      dialogVisible: false,
      batchForm: {
        field: '',  // 选择的字段
        value: ''   // 新值
      },
      inputType: 'text',  // 输入框类型
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      filteredList: null, // 过滤后的列表数据
      total: 0,
      listLoading: true,
      FileName: '资产台账导入模版.xlsx',
      url: '/AssetInfos/StationImport',
      importDialogVisible: false,
      changeRecords: [], // 资产变动记录
      changeRecordsTotal: 0, // 变动记录总数
      changeRecordsQuery: { // 变动记录查询条件
        page: 1,
        limit: 10,
        assetCode: undefined
      },
      dateRange: null, // 日期区间
      listQuery: {
        // 查询条件
        page: 1,
        limit: 100,
        assetCode: undefined, // 资产编号
        key: undefined, // 名称或规格
        department: undefined, // 部门
        startDate: undefined, // 开始日期
        endDate: undefined, // 结束日期
        minAmount: undefined, // 最小金额
        maxAmount: undefined, // 最大金额
      },
      temp: {
        assetCode: undefined,
        assetName: undefined,
        serviceLife: undefined,
        purchaseDate: "2025-03-09",
        useUnit: undefined,
        purchaseAmount: undefined,
        rfid: undefined,
        specification: undefined,
        assetResidual: undefined,
        serialNumber: undefined,
        depreciations: "平均年限法",
        assetAd: undefined,
        useDepartment: undefined,
        useMan: undefined,
        storeName: undefined
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },

      rules: {
        assetCode: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        assetName: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        serviceLife: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        purchaseDate: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        useUnit: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        purchaseAmount: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        assetResidual: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        assetAd: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }]
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('storeName', '仓库', true, true, '', '', 'string', 'varchar', 'StoreName', '100px'),
      new ColumnDefine('useDepartment', '使用部门', true, true, '', '', 'string', 'varchar', 'UseDepartment', '120px'),
      new ColumnDefine('assetCode', '资产编号', true, true, '', '', 'string', 'varchar', 'AssetCode', '120px'),
      new ColumnDefine('assetName', '资产名称', true, true, '', '', 'string', 'varchar', 'AssetName', '120px'),
      new ColumnDefine('specification', '规格型号', true, true, '', '', 'string', 'varchar', 'Specification', '120px'),
      new ColumnDefine('serialNumber', 'SN', true, true, '', '', 'string', 'varchar', 'SerialNumber', '100px'),
      new ColumnDefine('location', '存放地点', true, true, '', '', 'string', 'varchar', 'Location', '120px'),
      new ColumnDefine('useMan', '使用人', true, true, '', '', 'string', 'varchar', 'UseMan', '100px'),
      new ColumnDefine('purchaseDate', '日期', true, true, '', '', 'DateTime', 'datetime', 'PurchaseDate', '120px'),
      new ColumnDefine('purchaseAmount', '原值', true, true, '', '', 'decimal', 'decimal', 'PurchaseAmount', '100px'),
      new ColumnDefine('assetResidual', '资产残值', true, true, '', '', 'decimal', 'decimal', 'AssetResidual', '120px'),
      new ColumnDefine('serviceLife', '使用年限', true, true, '', '', 'int', 'int', 'ServiceLife', '120px'),
      new ColumnDefine('monthlyDepreciation', '每月折旧', true, true, '', '', 'decimal', 'decimal', 'MonthlyDepreciation', '120px'),
      new ColumnDefine('assetAd', '累计折旧', true, true, '', '', 'decimal', 'decimal', 'AssetAd', '120px'),
      new ColumnDefine('depreciations', '折旧方法', true, true, '', '', 'string', 'varchar', 'Depreciations', '120px'),
      new ColumnDefine('useUnit', '使用单位', true, true, '', '', 'string', 'varchar', 'UseUnit', '120px'),
      new ColumnDefine('rfid', 'RFID', true, true, '', '', 'string', 'varchar', 'Rfid', '120px'),
      new ColumnDefine('state', '状态', true, true, '', '', 'string', 'varchar', 'State', '100px'),
      new ColumnDefine('maintStatus', '维修状态', true, true, '', '', 'string', 'varchar', 'MaintStatus', '120px'),
      new ColumnDefine('netValue', '资产净值', true, true, '', '', 'decimal', 'decimal', 'NetValue', '100px'),
      new ColumnDefine('increaseMethod', '增加方式', true, true, '', '', 'string', 'varchar', 'IncreaseMethod', '80px'),
      new ColumnDefine('totalMonths', '应提总月数', true, true, '', '', 'int', 'int', 'TotalMonths', '80px'),
      new ColumnDefine('usedMonths', '已提总月数', true, true, '', '', 'int', 'int', 'UsedMonths', '80px'),
      new ColumnDefine('remark', '备注', true, true, '', '', 'string', 'varchar', 'Remark', '120px'),
    ];
    console.log(this.headerList)
    this.getList()
  },
  methods: {
    // 显示对话框
    showBatchEditDialog() {
      this.dialogVisible = true;
      // 重置表单
      this.$nextTick(() => {
        this.$refs.batchForm.resetFields();
        this.inputType = 'text';
      });
    },

    // 关闭对话框前处理
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
        })
        .catch(() => { });
    },

    // 下拉选择变化时调整输入框类型
    handleFieldChange(value) {
      const selectedColumn = this.headerList.find(item => item.columnName === value);
      if (selectedColumn) {
        switch (selectedColumn.entityType) {
          case 'int':
          case 'decimal':
            this.inputType = 'number';
            break;
          case 'DateTime':
            this.inputType = 'date';
            break;
          default:
            this.inputType = 'text';
            break;
        }
      }
    },

    // 确认批量修改
    handleBatchUpdate() {
      if (!this.batchForm.field || !this.batchForm.value) {
        this.$message.warning('请选择字段并输入新值');
        return;
      }
      const updateData = {
        field: this.batchForm.field,
        value: this.batchForm.value,
        ids: this.multipleSelection.map(row => row.id)
      };
      console.log(JSON.stringify(updateData))
      assetInfos.saveBatchUpdate(JSON.stringify(updateData)).then(() => {
        this.$message.success('批量修改成功');
        this.dialogVisible = false;
        this.getList();
      });
    },


    generateQRCode() {
      const canvas = this.$refs.qrCanvas;
      if (this.temp.assetCode) {
        // 单位编号
        const storedTenantId = localStorage.getItem('tenantId');

        QRCode.toCanvas(canvas, storedTenantId + "," + this.temp.assetCode, { width: 200 }, (error) => {
          if (error) console.error(error);
          console.log('二维码生成成功！');
        });
      }
    },
    rowClick(row) {
      //      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (!prop || !order) return;

      const data = this.filteredList || this.list;
      const sortedData = [...data];

      sortedData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        // 处理数字类型
        if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // 处理日期类型
        if (valueA && valueB && !isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // 按照顺序排序
        if (order === 'ascending') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      this.list = sortedData;
    },

    // 处理表格筛选
    handleFilterChange(filteredData) {
      this.filteredList = filteredData;
      this.list = filteredData;
      this.total = filteredData.length;
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'bulkedit':
          if (this.multipleSelection.length == 0) {
            this.$message({
              message: '请至少选择一条数据',
              type: 'error',
            })
            return
          }
          this.showBatchEditDialog()
          break
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        case 'Import':
          this.FileName = '资产台账导入模版.xlsx';
          this.url = '/AssetInfos/StationImport';
          this.importDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.ImportDialog.openDialog();
          });
          break
        case 'Batchupdate':
          this.FileName = '资产台账RDID更新模版.xlsx'
          this.url = '/AssetInfos/StationUpdate'
          this.importDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.ImportDialog.openDialog();
          });
          break;
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      assetInfos.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.filteredList = null // 重置过滤数据
        this.total = response.count
        this.listLoading = false
        this.dialogFormVisible = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleReset() {
      // 重置搜索条件
      this.listQuery.assetCode = undefined
      this.listQuery.key = undefined
      this.listQuery.department = undefined
      this.listQuery.startDate = undefined
      this.listQuery.endDate = undefined
      this.listQuery.minAmount = undefined
      this.listQuery.maxAmount = undefined
      this.dateRange = null
      this.listQuery.page = 1
      this.getList()
    },
    handleDateRangeChange(val) {
      // 处理日期区间变化
      if (val && val.length === 2) {
        this.listQuery.startDate = val[0]
        this.listQuery.endDate = val[1]
      } else {
        this.listQuery.startDate = undefined
        this.listQuery.endDate = undefined
      }
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.temp.depreciations = "平均年限法",
        this.getTenantOptions();
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      // 保存提交
      this.$refs['dataForm'].validate((val) => {
        if (!val) return;
        assetInfos.add(this.temp).then(() => {
          this.list.unshift(this.temp)
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        })
      })
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.getTenantOptions(); // 获取单位名称
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        if (this.temp.assetCode) {
          this.generateQRCode()
          // 获取资产变动记录
          this.getAssetChangeRecords(this.temp.assetCode)
        }
      })
    },
    updateData() {
      // 更新提交
      this.$refs['dataForm'].validate((val) => {
        if (!val) return;
        const tempData = Object.assign({}, this.temp)
        assetInfos.update(tempData).then(() => {
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v)
              this.list.splice(index, 1, this.temp)
              break
            }
          }
          this.dialogFormVisible = false
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        })
      })
    },
    async getTenantOptions() {
      try {
        // 获取租户ID
        const tenantId = localStorage.getItem('tenantId');
        console.log('tenantId:', tenantId);
        if (!tenantId) {
          console.error('未获取到租户ID');
          return;
        }
        // 获取单位列表
        const res = await getTenantList(tenantId);
        if (res && res.result) {
          this.tenantName = res.result[0].tenantName;
          this.temp.useUnit = res.result[0].tenantName;
        } else {
          console.error('获取单位列表失败', res);
        }
      } catch (error) {
        console.error('获取单位列表出错:', error);
        this.$message.error('获取单位信息失败');
      }

    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(assetInfos, rows)
    },
    // 获取资产变动记录
    getAssetChangeRecords(assetCode) {
      // 设置查询条件
      this.changeRecordsQuery.assetCode = assetCode;
      this.changeRecordsQuery.page = 1; // 重置到第一页
      assetInfos.getChangeRecords(this.changeRecordsQuery).then(response => {
        this.changeRecords = response.data;
        this.changeRecordsTotal = response.count;
      })
    },

    // 处理变动记录分页
    handleChangeRecordsPagination(val) {
      this.changeRecordsQuery.page = val.page;
      this.changeRecordsQuery.limit = val.limit;

      // 重新获取数据
      assetInfos.getChangeRecords(this.changeRecordsQuery).then(response => {
        this.changeRecords = response.data;
        this.changeRecordsTotal = response.count;
      })
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

.asset-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 400px;
}

.asset-card {
  border: 2px solid #333;
  border-radius: 8px;
  width: 700px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: #f5f5f5;
  padding: 15px 20px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  text-align: center;
  border-bottom: 2px solid #333;
}

.card-body {
  display: flex;
  padding: 30px 20px;
}

.card-left {
  flex: 1;
  padding-right: 20px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
  font-size: 16px;
  color: #666;
}

.info-row .label {
  min-width: 60px;
  font-weight: 500;
}

.info-row .value {
  flex: 1;
  color: #333;
}

.qr-code-text {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
  letter-spacing: 2px;
}

.card-right {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  border-left: 1px solid #e0e0e0;
}

.card-right canvas {
  display: block;
}
</style>
